<template>
  <div>
    <div class="bg-white rounded-md h-screen m-3">
      <div class="border-b-0.5 flex justify-between items-center">
        <p class="p-2 text-sm">For my action</p>
        <!-- <img class="h-4 cursor-pointer pr-2" src="@/assets/icons/add.png" /> -->
      </div>
      <div class="flex flex-col gap-y-1 p-2">
        <!-- {{ pendingTrainings }} -->
        <div v-for="(item, index) in items" :key="index">
          <div
            :class="
              open == index ? 'border-none shadow' : 'border-1.5 rounded-md'
            "
            @click="view(index)"
            class="flex justify-between items-center border-1.5 p-2 rounded-md cursor-pointer"
          >
            <p class="text-sm">{{ item.type }} ({{ item.info.length }})</p>
            <img
              class="h-4"
              :class="
                open == index ? '-rotate-0 transform' : '-rotate-90 transform'
              "
              src="@/assets/icons/caret.png"
            />
          </div>
          <div v-if="item.info.length > 0">
            <transition name="accordion">
              <div v-if="open == index" class="h-64 overflow-y-scroll">
                <div v-for="(item, index) in item.info" :key="index">
                  <div
                    class="flex gap-4 justify-start p-3 items-center cursor-pointer hover:bg-gray-100 border-b-0.5"
                    @click="goToProfile(item.routeName, item.tab, item.path)"
                  >
                    <div
                      class="h-10 w-10 rounded-full bg-gray-400 flex items-center justify-center"
                    >
                      <img
                        v-if="item.image"
                        class="h-full w-full rounded-full object-cover"
                        :src="item.image"
                        :alt="getInitials(item.Name)"
                      />

                      <span class="text-white" v-else>
                        {{ getInitials(item.Name) }}
                      </span>
                    </div>

                    <div class="text-xs">
                      <p class="font-bold">
                        {{ decryptDataLocal(item.Name, $decryptionKey) }}
                      </p>
                      <span>{{ item.Value }}</span>
                      <p
                        v-if="item.Type"
                        class="p-0.5 rounded-sm mt-1 font-bold"
                      >
                        {{ item.Type }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <div v-if="!item.info.length && open == index && !loading">
            <el-empty :image-size="70" description="No Data"></el-empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import decryptData from "@/utils/decrypt";
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "ForMyAction",
  data() {
    return {
      routerName: "profile",
      paramName: "claims",
      decryptedEmployeeName: "",
      pendingTrainings: null,
      key: "",
      open: 0,
      items: [
        {
          type: "Leave Application",
          info: [],
        },
        {
          type: "Employee Claims",
          info: [],
        },
        {
          type: "Contract Renewals",
          info: [],
        },
        {
          type: "Job Applications",
          info: [],
        },
        {
          type: "Training Requests",
          info: [],
        },
        {
          type: "Upcoming Interviews",
          info: [],
        },
      ],
    };
  },
  created() {
    this.decryptDataLocal = decryptData;
    this.getTeamLeaves();
    this.getTeamClaims();
    this.getTeamTrainings();
    this.getTeamContracts();
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken", "getUser"]),
  },

  methods: {
    goToProfile(routeName, tab) {
      const user = this.getUser;
      this.$store.commit("setCurrentEmployeeId", user.Id);
      routeName == "training"
        ? this.$router.push({
            name: routeName,
            params: { type: "team", company: this.getOrganization },
          })
        : this.$router.replace({
            name: routeName,
            params: {
              type:"team",
              user: JSON.stringify(user),
              tab: tab,
              company: this.getOrganization,
            }, // pass the user object as a string using JSON.stringify
          });
    },
    getInitials(fullname) {
      if (!fullname) return ""; // Handle case where fullname is not provided

      let decryptedEmployeeName = decryptData(fullname, this.$decryptionKey);
      const names = decryptedEmployeeName?.split(" ");

      if (!names) return ""; // Handle case where decryptedEmployeeName is not provided

      const initials = names
        .map((name) => name[0])
        .join("")
        .toUpperCase();

      return initials;
    },
    view(index) {
      if (index == this.open) {
        this.open = null;
      } else {
        this.open = index;
      }
    },

    getTeamLeaves() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
        },
      };

      axios
        .get(
          `${this.getOrganization}/timeoff/myteam/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.status === 200) {
              this.$emit("closeOnSuccess");

              let leavesWithinThisWeekFromToday = response.data.Data.filter(
                (leave) => {
                  return (
                    leave.Status.trim().toLowerCase() === "pending"
                    //  &&
                    // this.isWithinAWeekFromToday(leave.StartDate)
                  );
                }
              );

              const uniqueItems = {};
              leavesWithinThisWeekFromToday.forEach((item) => {
                uniqueItems[item.Id] = item;
              });

              let uniqueItemsWithoutTestLeaves = Object.values(
                uniqueItems
              ).filter(
                (d) => d.LeaveType !== "Test" && d.Name !== "Tony Rotich"
              );

              this.items[0].info = uniqueItemsWithoutTestLeaves.map((item) => {
                return {
                  Name: item.Name,
                  Value: `From ${moment(item.StartDate).format(
                    "DD/MM/YYYY"
                  )} to ${moment(item.EndDate).format("DD/MM/YYYY")} (${
                    item.Period
                  } day${item.Period > 1 || item.Period < 1 ? "s" : ""})`,
                  Type: item.LeaveType,
                  routeName: "timeoff",
                  tab: "team",
                  path: "/timeoff/:type",
                };
              });
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    // /{organization}/employee/claim/myteam/v1/request
    getTeamClaims() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
        },
      };

      axios
        .get(
          `${this.getOrganization}/employee/claim/myteam/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.status === 200) {
              this.$emit("closeOnSuccess");

              // Filter claims based on the condition
              let claimsWithinThisWeekFromToday = response.data.Data.filter(
                (claim) => {
                  return (
                    claim.Status === 0 &&
                    this.isWithinAWeekFromToday(claim.DateApplied)
                  );
                }
              );

              // Now you can proceed with filtering unique items and converting them back to an array as you did before
              const uniqueItems = {};
              claimsWithinThisWeekFromToday.forEach((item) => {
                uniqueItems[item.Id] = item;
              });

              let uniqueItemsWithoutTestClaims = Object.values(
                uniqueItems
              ).filter((d) => d.ClaimType !== "Test");

              // Map through this.items[0].info
              this.items[1].info = uniqueItemsWithoutTestClaims.map((item) => {
                return {
                  Name: item.Name, // Replace with the actual property name from your data
                  Value: `Applied on ${moment(item.DateApplied).format(
                    "DD/MM/YYYY"
                  )} `,
                  Type: item.ClaimType,
                  routeName: "profile",
                  tab: "claims",
                  path: "",
                };
              });
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    // /{organization}/dashboard/contract/v1/expiring
    getTeamContracts() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
        },
      };

      axios
        .get(
          `${this.getOrganization}/dashboard/contract/${this.$ApiVersion}/expiring`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.status === 200) {
              this.$emit("closeOnSuccess");
              console.log(response.data.Data);
              // Filter claims based on the condition
              let contracts = response.data.Data;

              // Now you can proceed with filtering unique items and converting them back to an array as you did before
              const uniqueItems = {};
              contracts.forEach((item) => {
                uniqueItems[item.Id] = item;
              });

              let uniqueItemsContracts = Object.values(uniqueItems);

              // Map through this.items[0].info
              this.items[2].info = uniqueItemsContracts.map((item) => {
                return {
                  Name: decryptData(item.EmployeeName, this.$decryptionKey), // Replace with the actual property name from your data
                  Value: `From ${moment(item.StartDate).format(
                    "DD/MM/YYYY"
                  )} to ${moment(item.EndDate).format("DD/MM/YYYY")}`,
                  Type: item.EmploymentType,
                  routeName: "profile",
                  tab: "Job Information",
                  path: "",
                };
              });
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    getTeamTrainings() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
        },
      };

      axios
        .get(
          `${this.getOrganization}/training/team/${this.$ApiVersion}/query`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.status == 200) {
              this.pendingTrainings = response.data.Data.filter(
                (training) => training.Status === "Pending"
              ).sort((a, b) => new Date(a.StartDate) - new Date(b.StartDate));

              this.items[4].info = this.pendingTrainings.map((training) => {
                return {
                  Name: training.Name, // Replace with the actual property name from your data
                  Value: `Starts on ${moment(training.StartDate).format(
                    "DD/MM/YYYY"
                  )} `,
                  Type: "",
                  routeName: "training",
                  tab: "claims",
                  path: "/:company/training/:type",
                };
              });
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },

    // Function to check if a date is within 7 days from today
    isWithinAWeekFromToday(itemDate) {
      let isoDateString = new Date(itemDate).toISOString();
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0); // Set time to 00:00:00

      const sevenDaysFromToday = new Date(currentDate);
      sevenDaysFromToday.setDate(currentDate.getDate() + 7);

      return (
        isoDateString >= currentDate.toISOString() &&
        isoDateString <= sevenDaysFromToday.toISOString()
      );
    },
  },
};
</script>
